module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_view),
      expression: "show_view"
    }],
    staticClass: "row m-t-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "name": "verifyCode",
      "placeholder": "验证码",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": [function($event) {
        _vm.validateCode()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-6 n-p-l "
  }, [_c('button', {
    staticClass: "btn btn-primary btn-md col-xs-12",
    attrs: {
      "type": "button ",
      "disabled": _vm.reset.disabled
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.reset.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-tips "
  }, [_vm._v(_vm._s(_vm.msg))])])]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('button', {
    staticClass: "btn btn-primary btn-md col-xs-12 verify-btn",
    attrs: {
      "type": "button ",
      "disabled": _vm.validate.disabled
    },
    on: {
      "click": function($event) {
        _vm.completeVerify()
      }
    }
  }, [_vm._v("验证" + _vm._s(_vm.type_text))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3629334c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/verify-code.vue
// module id = 474
// module chunks = 1